/**
 * WarrantyWidget – Birdie Care Plan custom element
 *
 * Manages the toggle state for all care-plan widgets on the page.
 * Cart integration is handled by product-form.js which reads
 * window.warrantyActive and calls upsellProduct if a widget with
 * data-care-plan-variant-id is active at submit time.
 */
class WarrantyWidget extends HTMLElement {
  constructor() {
    super();

    window.defaultActive = false;

    if (document.querySelectorAll('warranty-widget').length < 1) {
      if (window.defaultActive || window.warrantyActive) {
        window.warrantyActive = true;
        this.classList.add('active');
      } else {
        window.warrantyActive = false;
      }
    } else {
      if (window.warrantyActive) {
        window.warrantyActive = true;
        this.classList.add('active');
      } else {
        window.warrantyActive = false;
      }
    }

    this._syncAriaChecked();
    this.addEventListener('click', () => this.toggleWarranty());
  }

  /** Toggle care-plan ON / OFF across all widgets on the page */
  toggleWarranty() {
    if (window.warrantyActive) {
      document.querySelectorAll('warranty-widget').forEach((w) => {
        w.classList.remove('active');
      });
      window.warrantyActive = false;
    } else {
      document.querySelectorAll('warranty-widget').forEach((w) => {
        w.classList.add('active');
      });
      window.warrantyActive = true;
    }
    this._syncAriaChecked();
  }

  /** Keep toggle aria-checked in sync for accessibility */
  _syncAriaChecked() {
    document.querySelectorAll('warranty-widget').forEach((w) => {
      const toggle = w.querySelector('.warranty-toggle');
      if (toggle) toggle.setAttribute('aria-checked', window.warrantyActive ? 'true' : 'false');
    });
  }

  /**
   * Returns the care plan Shopify variant ID stored on this widget,
   * or null if not set. Used by product-form.js for cart integration.
   */
  get carePlanVariantId() {
    const id = this.dataset.carePlanVariantId;
    return id ? parseInt(id, 10) : null;
  }
}

customElements.define('warranty-widget', WarrantyWidget);
